import { render, staticRenderFns } from "./ChoosePurchaseItemV2.vue?vue&type=template&id=76b4fbc2&scoped=true"
import script from "./ChoosePurchaseItemV2.vue?vue&type=script&lang=js"
export * from "./ChoosePurchaseItemV2.vue?vue&type=script&lang=js"
import style0 from "./ChoosePurchaseItemV2.vue?vue&type=style&index=0&id=76b4fbc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b4fbc2",
  null
  
)

export default component.exports